import moment from "moment";

export const displayDateFormat = "M/D/YYYY";
export const isoDateFormat = "YYYY-MM-DD";
export const isoDateTimeFormat = "YYYY-MM-DD HH:mm:ss";
export const seriesTimeFormat = "MM/D/YYYY h:mm:ss A Z";

export function formatDateDisplay(date) {
  return moment(date).format(displayDateFormat);
}

export function formatDateISO(date){
  return moment(date).format(isoDateFormat);
}